import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { canAccessRfidEngineAdmin } from '@/utils/rfidAccess'

/**
 * Route gate: IAM app `RFID` + role `RFID Admin`.
 */
export function RfidEngineAdminRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  if (!canAccessRfidEngineAdmin(user)) {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
